.heading {
  padding-top: 2em;
  padding-bottom: 0;
}

.instructionText {
  padding-top: 1em;
}
